// extracted by mini-css-extract-plugin
export default {"clickable":"TableItem_clickable__POjcc","icon":"TableItem_icon__DM0ZY"};